import { useDonationFormInfo, useEventInfo } from '@frx/frx-react-context';
import { useLowercaseQueryString } from './useLowercaseQueryString';
import { ASK_ARRAY, ASK_ARRAY_SIZES } from '../constants';

export const useDonationForm = () => {
  const { queryStrings } = useLowercaseQueryString();

  const { data, isError, isLoading, isSuccess } = useDonationFormInfo();

  const getOtherAmount = () => {
    if (queryStrings['set.value']) {
      const otherAmount: string = queryStrings['set.value'];

      if (!Number.isNaN(otherAmount)) {
        const numberFormatted = (+otherAmount / 100).toFixed(2);

        if (+numberFormatted >= 5 && +numberFormatted <= 2000000) {
          return numberFormatted;
        }
      }
    }

    return null;
  };

  const { data: trInfo } = useEventInfo();
  const eventType = (trInfo?.public_event_type_name || '').toLowerCase();
  const levels = ASK_ARRAY[eventType] || ASK_ARRAY_SIZES.md;
  const getDefaultIndexValue = () => {
    const { length } = levels;

    if (length === 3 || length === 4) return Number(levels[1]);
    if (length >= 5) return Number(levels[2]);
    return 0;
  };

  const getOtherLevelId = () =>
    data?.donationLevels?.donationLevel?.find((d) => d.userSpecified)
      ?.level_id || 0;

  const levelOption = (dL: { level_id: number; name: string }) =>
    dL.level_id === Number(queryStrings['set.donationlevel']) &&
    dL.name.includes('Level');

  const getDefaultAmount = () => {
    const donationLevelCount = data?.donationLevels.donationLevel.length || 0;
    /* Establish a fallback default level. If we can't identify the default from the query params, 
       then fallback to the second donation level.
       If, for some reason we only have only have one donation level then take the first instead. */
    /**
     * IF donationLevel is valid Level 1-x array USE donationLevel amount (Array position)
     * IF donationLevel is NOT in donationLevels array USE Default value
     * IF donationLevel is invalid USE Default value
     * IF set.value exist and is NOT valid USE Default value (and ignore Donation level rules)
     */
    const defaultValue =
      data?.donationLevels.donationLevel[donationLevelCount > 1 ? 1 : 0];

    if (queryStrings['set.value'] && !getOtherAmount()) {
      return {
        level_amount: Number(defaultValue?.amount.decimal),
        level_id: defaultValue?.level_id,
      };
    }

    if (queryStrings['set.donationlevel'] && !getOtherAmount()) {
      const donationLevelFound =
        data?.donationLevels.donationLevel.find(levelOption);
      if (donationLevelFound) {
        return {
          level_amount: Number(donationLevelFound?.amount.decimal),
          level_id: donationLevelFound?.level_id,
        };
      }
    }

    // eslint-disable-next-line  @typescript-eslint/no-non-null-assertion
    return {
      level_amount: Number(defaultValue?.amount.decimal),
      level_id: defaultValue?.level_id,
    };
  };

  return {
    error: isError,
    isLoading,
    isSuccess,
    form: data,
    queryStrings,
    getDefaultIndexValue,
    getDefaultAmount,
    getOtherAmount,
    getOtherLevelId,
  };
};
